
<div *ngIf="hasErrors" class="row">
  <div class="col">
    <div class="alert alert-danger d-flex align-items-center alert-danger-custom" role="alert">
      <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Danger:"><use xlink:href="#exclamation-octagon-fill"/></svg>
      <div style="color: white">At least 1 selection is required</div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col">
    <kendo-label [text]="labelName" class="input-label-header" [for]="checkboxTreeview"></kendo-label>
  </div>
</div>
<hr class="input-label-header-hr" />
<div class="row">
  <div class="col">
    <kendo-treeview
      #checkboxTreeview
      [nodes]="indication.inputOptions"
      [children]="children"
      [hasChildren]="hasChildren"
      textField="displayName"
      [kendoTreeViewCheckable]="checkableSettings"
      [(checkedKeys)]="checkedKeys"
      [checkBy]="checkedKey"
      [isChecked]="isChecked"
      [style.cursor]="'pointer'"
      (checkedKeysChange)="checkedChange($event)"
    ></kendo-treeview>
    <br />
    <button *ngIf="!hasCustomControlParent" kendoButton (click)="setDefaults()">Set Default Values</button>
  </div>
</div>

